import React, { useEffect } from "react";

import CloseIcon from "./assets/close.svg";
import { translate } from "react-polyglot";
import { isMobile } from 'lib/checkuseros';


import "./styles.less";
import Button from "../../button";

const QRPopup = ({ closePopup, actionButtonClick, t }) => {
  const isMobileOS = isMobile()

  useEffect(() => {
    const handleKeyPress = e => {
      if (e.code !== "Escape") return;
      closePopup();
    };

    window.addEventListener("keydown", handleKeyPress);
    document.body.style.overflow = "hidden";

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
      document.body.style.overflow = "unset";
    };
  });




  return (
    <div onClick={closePopup} className={`qr-popup ${isMobileOS ? 'qr-popup--mobile': 'qr-popup--desktop'}`}>
      <div onClick={e => e.stopPropagation()} className="qr-popup__inner">
        <button className="qr-popup__close" onClick={closePopup}>
          <img src={CloseIcon} alt="close popup icon" />
        </button>

        <div className="qr-popup__content--mobile">
          <div className="qr-popup__content">
            <p className="qr-popup__content-text">{t("landing.qr-popup.mobile.title")}</p>
            <p className="qr-popup__content-description">{t("landing.qr-popup.mobile.description")}</p>
            <div>
              <Button
                handleClick={actionButtonClick}
                text={t("landing.qr-popup.mobile.button")}
                variant="default"
                size="md"
                isStore
              />
            </div>
          </div>
        </div>
        <div className="qr-popup__content--desktop">
          <div className="qr-popup__content">
            <p className="qr-popup__content-text">{t("landing.qr-popup.desktop.title")}</p>
            <img
              className="qr-popup__content-qr"
              src="https://www.bigizone.co.il/assets/qr_code.png"
              alt="QR code"
            />
            <div>
              <Button
                handleClick={actionButtonClick}
                text={t("landing.qr-popup.desktop.button")}
                variant="default"
                size="md"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default translate()(QRPopup);



// WEBPACK FOOTER //
// ./src/js/components/pages/newLandingPage/ui/qr-popup/index.js